<tcc-mono-dialog-layout
  title="Dier opzoeken"
  [displayBottomButtons]="true"
  saveText="Zoeken"
  (onSave)="submit()"
>
  <div class="lookup-content">
    <ion-text *ngIf="error" color="danger" class="lookup-error">
      <p>{{ error }}</p>
    </ion-text>

    <ion-select
      mode="ios"
      [formControl]="speciesCtrl"
      labelPlacement="stacked"
      interface="popover"
    >
      <ion-text slot="label" class="form-label required">Type</ion-text>
      <ion-select-option *ngFor="let option of speciesOptions" [value]="option.value">
        {{ option.label }}
      </ion-select-option>
    </ion-select>

    <ion-segment mode="ios" [formControl]="countryCtrl">
      <ion-segment-button value="NL">NL</ion-segment-button>
      <ion-segment-button value="DK">DK</ion-segment-button>
      <ion-segment-button value="BE">BE</ion-segment-button>
      <ion-segment-button value="DE">DE</ion-segment-button>
    </ion-segment>

    <ion-input
      mode="ios"
      [formControl]="idCtrl"
      (keydown)="onKeyDown($event)"
      #scanInput
      labelPlacement="stacked"
      errorText="Levensnummer is verplicht"
      placeholder="Scan of voer levensnummer in"
    >
      <ion-text slot="label" class="form-label required">Levensnummer</ion-text>
    </ion-input>

    <p class="lookup-tip">
      Tip: je kunt ook een gecombineerde code plakken (bijv.
      <span class="mono">DE0125807487</span>) — we splitsen dit automatisch in landcode + levensnummer.
    </p>
  </div>

  <div slot="left-buttons">
    <ion-button mode="ios" fill="clear" color="medium" (click)="close()">
      Sluiten
    </ion-button>
  </div>
</tcc-mono-dialog-layout>
